import {
  React,
  useState,
  useEffect,
  LoaderOverlay,
  withAuth,
  toast,
  connect,
  useDispatch,
  useSelector,
  useNavigate,
  MESSAGES,
  useParams,
} from "./../../common/helper/common-imports.component.js";
import "./login.css";
import { authentication, getUser } from "./../../../actions/auth-actions";
import LoginService from "./../../../services/auth-service";
import CryptoJS from "crypto-js";
import { FormField } from "./../../common/helper/formFields";
import useIsMobile from "../../common/hooks/useIsMobile.js";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isError, setIsError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const isMobile = useIsMobile();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const validateField = (fieldName, value) => {
    let errorMessage = "";

    if (fieldName === "email") {
      if (!value.trim()) {
        errorMessage = "Email is required";
      } else if (!validateEmail(value)) {
        errorMessage = "Invalid email format";
      }
    } else if (fieldName === "password" && !value.trim()) {
      errorMessage = "Password is required";
    }

    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // // Validate form fields
    Object.keys(formData).forEach((fieldName) =>
      validateField(fieldName, formData[fieldName])
    );

    const hasErrors = Object.values(formData).some((value) => value === "");

    if (!hasErrors) {
      setLoading(true);
      dispatch(authentication(formData))
        .then((response) => {
          setIsError(false);
          LoginService.setAccessToken(response.data);
          dispatch(getUser()).then((response) => {
            if (rememberMe) {
              localStorage.setItem("rememberMeEmail", formData.email);
              localStorage.setItem(
                "rememberMePassword",
                CryptoJS.AES.encrypt(
                  formData.password,
                  "secret key 123"
                ).toString()
              );
            } else {
              localStorage.removeItem("rememberMeEmail");
              localStorage.removeItem("rememberMePassword");
            }

            if (useUserPermissionData(response, "dashboard_agent")) {
              navigate("/dashboard");
            } else if (useUserPermissionData(response, "dashboard_owner")) {
              navigate("/admin-dashboard");
            } else if (useUserPermissionData(response, "dashboard_merchant")) {
              navigate("/merchant-dashboard");
            } else if (useUserPermissionData(response, "user_management")) {
              navigate("/users");
            } else if (
              useUserPermissionData(response, "transaction_management")
            ) {
              navigate("/transactions");
            } else if (
              useUserPermissionData(response, "commission_management")
            ) {
              navigate("/commissions");
            } else if (useUserPermissionData(response, "agent_management")) {
              navigate("/agents");
            } else if (useUserPermissionData(response, "merchant_management")) {
              navigate("/merchants");
            } else if (
              useUserPermissionData(response, "payment_method_system")
            ) {
              navigate("/admin-payments");
            } else if (
              useUserPermissionData(response, "commission_group_management")
            ) {
              navigate("/commission-groups");
            } else if (
              useUserPermissionData(response, "limit_group_management")
            ) {
              navigate("/limits");
            } else if (useUserPermissionData(response, "payment_method_user")) {
              navigate("/payment-methods");
            } else if (useUserPermissionData(response, "crypto_merchant")) {
              navigate("/crypto-list");
            } else {
              navigate("/users");
            }
            setLoading(false);
          });
        })
        .catch((error) => {
          try {
            const errorMessage = error.response.data;
            toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
          } catch (e) {
            toast.error(MESSAGES.SERVER_ERROR);
          }
          // const errorMessage = error.response.data
          setIsError(true);
          setLoading(false);
          // setErrorMsg(errorMessage.error.message);
        });
    }
  };
  const forgotPass = () => {
    navigate("/forgot-password");
  };
  useEffect(() => {
    const rememberedEmail = localStorage.getItem("rememberMeEmail");
    const rememberedPassword = localStorage.getItem("rememberMePassword");
    if (rememberedEmail && rememberedPassword) {
      setFormData({
        email: rememberedEmail,
        password: CryptoJS.AES.decrypt(
          rememberedPassword,
          "secret key 123"
        ).toString(CryptoJS.enc.Utf8),
      });
      setRememberMe(true);
    } else {
      setFormData({
        email: "",
        password: "",
      });
    }
    document.body.style.backgroundImage = "url('assets/img15.jpg')";
    document.body.style.backgroundSize = "cover";

    document.getElementsByClassName("login-form")[0].style.backgroundImage =
      "url('assets/img6.avif')";
    document.getElementsByClassName("login-form")[0].style.backgroundSize =
      "cover";

    return () => {
      document.body.style.backgroundColor = ""; // Reset body color when ComponentOne unmounts
    };
  }, [isMobile]);

  const useUserPermissionData = (userData, permcode) => {
    if (
      !userData ||
      !userData.data ||
      !userData.data.role ||
      !userData.data.role.permissions
    )
      return false;

    const permissionArr = userData.data.role.permissions;
    return permissionArr.some(
      (permission) => permission.permission_code === permcode
    );
  };

  return (
    <>
      <LoaderOverlay loading={loading} />
      <div
        className="container-fluid vh-100 m-0"
        style={{ padding: isMobile ? "0px" : "90px 150px" }}
      >
        <div
          className={`row m-0 d-flex align-items-center login-box-shadow ${isMobile && "h-100"}`}
          style={{
            borderRadius: isMobile ? "20px" : "40px",
            overflow: "hidden",
            padding: isMobile ? "0px 25px " : "0px",
          }}
        >
          {/* Left side - Image (70%) */}
          <div
            className="col-lg-7 d-none d-lg-block p-0 position-relative"
            style={{ height: isMobile ? "100%": "530px" }}
          >
            <img
              src="assets/img9.avif"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                opacity: "0.8",
              }}
            ></img>
            <div
              className="position-absolute bottom-0 start-0 p-5 text-white"
              style={{
                background:
                  "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
              }}
            >
              <h2
                className="display-5 fw-bold mb-3 text-white"
                style={{ color: "white" }}
              >
                {process.env.REACT_APP_TITLE}
              </h2>
              <p className="fs-5 text-white" style={{ color: "white" }}>
                Giving you more autonomy to control your money.
              </p>
              <div style={{ border: "1px solid white", width: "120px" }}></div>
            </div>
          </div>

          {/* Right side - Login Form (30%) */}
          <div
            className={`login-form col-12 col-lg-5 d-flex align-items-center justify-content-center ${isMobile && "common-box-shadow"}`}
            style={{
              border: isMobile ? "1px solid #d3c0c0" : "",
              padding: isMobile ? "25px 0px" : "25px",
              borderRadius: isMobile ? "18px" : "",
             height: isMobile ? "": "530px"
            }}
          >
            <div
              className=" w-100"
              style={{
                maxWidth: "400px",
                padding: isMobile ? "0px 15px" : "0px",
              }}
            >
              {/* Logo and Header */}
              <div className="text-center mb-4">
                <img
                  src={process.env.REACT_APP_LOGO_URL}
                  alt="Logo"
                  className="mb-4"
                  style={{ width: "160px", height: "100px" }}
                />
                <h1 className="h2 mb-2 text-start">Sign in</h1>
                <p className="text-muted medium text-start">
                  Access the panel using your email and password.
                </p>
              </div>

              {/* Login Form */}
              <form
                method="post"
                id="login_form"
                name="login_form"
                action="#"
                onSubmit={handleSubmit}
              >
                <div className="form-group first">
                  {/* <label htmlFor="username">Email</label> */}
                  <FormField
                    type="text"
                    id="email"
                    name="email"
                    label="Email"
                    value={formData.email}
                    onChange={handleChange}
                    error={errors.email}
                    autoComplete="new-username"
                  />
                </div>
                <div className="form-group last mb-3">
                  {/* <label htmlFor="password">Password</label> */}
                  <FormField
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    label="Password"
                    value={formData.password}
                    onChange={handleChange}
                    error={errors.password}
                    autoComplete="new-password"
                  />
                  <i
                    className={`toggle-password fa fa-fw ${
                      showPassword ? "fa-eye" : "fa-eye-slash"
                    }`}
                    style={{ marginTop: errors.password ? "-46px" : "" }}
                    onClick={togglePasswordVisibility}
                  />
                </div>
                <div className="d-sm-flex mb-5 align-items-center">
                  <label className="control control--checkbox mb-3 mb-sm-0">
                    <span className="caption">Remember me</span>
                    <input
                      type="checkbox"
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                    />{" "}
                    <div className="control__indicator" />
                  </label>
                  <span
                    className="ml-auto"
                    onClick={forgotPass}
                    style={{ fontSize: "13.5px!important", fontWeight: 600 }}
                  >
                    <a
                      href="#"
                      className="forgot-pass"
                      style={{ textDecoration: "none" }}
                    >
                      Forgot Password
                    </a>
                  </span>
                </div>
                <input
                  type="submit"
                  value="Log In"
                  className="btn btn-block py-2 btn-bg-theme-Color"
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
